import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap"; // assuming react-bootstrap
import { DonorService } from "../../Services/Donor.Service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

function HealthQuestionnaire({ userData ,selectedGender, setToastMessage, setToastVariant, setShowToast, setLoading, type , onHide ,job}) {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({}); 

  useEffect(() => {
    fetchHealthQuestionnaire();
  }, [userData]);

  // Prefill answers when userData.health_info is available
  useEffect(() => {
    if (userData?.health_info?.length > 0) {
      const info = userData.health_info[0];
      const prefilled = {};

      Object.keys(info).forEach((key) => {
        if (key.startsWith("question_id")) {
          const qid = key.replace("question_id", "");
          let val = info[key];

          // Convert datetime to "yyyy-MM-dd HH:mm:ss"
          if (
            val &&
            typeof val === "string" &&
            /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)
          ) {
            const d = new Date(val);
            if (!isNaN(d.getTime())) {
              val = format(d, "yyyy-MM-dd HH:mm:ss");
            }
          }

          // Convert true/false → 1/0
          if (val === true) val = 1;
          if (val === false) val = 0;

          prefilled[qid] = val;
        }
      });

      setAnswers(prefilled);
    }
  }, [userData]);
  
  const fetchHealthQuestionnaire = async () => {
    try {
      const response = await DonorService.fetchHealthQuestionnaire();
      if (response.success) {
        setQuestions(response.health_question_data);
      }
    } catch (error) {
      console.error("Error fetching health questionnaire:", error);
    }
  };

  const handleAnswer = (qid, value) => {
    setAnswers((prev) => ({
      ...prev,
      [qid]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [qid]: "",
    }));
  };

  // Check if question should be displayed
  const shouldDisplay = (q) => {
    // 1. Gender-specific filtering
    if (q.gender_specific !== "no" && q.gender_specific !== selectedGender.toLowerCase()) {
    return false;
    }


    // 2. Parent dependency
    if (q.parent_question_id) {
      const parentAnswer = answers[q.parent_question_id];
      // Show only if parent answered Yes (1) and matches parent_question_option
      if (parentAnswer !== q.parent_question_option) {
        return false;
      }
    }

    return true;
  };
  // helper: returns true if question q has a user answer (0, 1, non-empty string, non-empty array, etc.)
  const isAnswered = (q) => {
    const val = answers[q.id];

    // not answered if undefined or null
    if (val === undefined || val === null) return false;

    // if string (text/date), require non-empty after trimming
    if (typeof val === "string") return val.trim().length > 0;

    // if array (multi-select etc.), require length > 0
    if (Array.isArray(val)) return val.length > 0;

    // numbers (0,1) and booleans are considered answered
    return true;
  };
  const handleSubmit = async() => {
    setLoading(true);
    let newErrors = {};
    let isValid = true;

    questions.forEach((group) => {
      group.health_questions.forEach((q) => {
        if (shouldDisplay(q)) {
           if (!isAnswered(q)) {
            newErrors[q.id] = "This field is required";
            isValid = false;
          }
        }
      });
    });

    setErrors(newErrors);

    if (isValid) {
      const payload = {
        user_id: userData?.id,
        gender: selectedGender,
      };

      // flatten answers into questionN
      Object.keys(answers).forEach((qid) => {
        payload[`question${qid}`] = answers[qid];
      });

      try {
        let res;
        if (type === 'donor') {
          payload.request_id = job?.request_id;  
          res = await DonorService.updateHealthDataJobBoardOpportunity(payload);
        } else {
          res = await DonorService.updateHealthData(payload);
        }

        console.log("Update success:", res);
        setToastMessage(res.message);
        setToastVariant('success')
        setShowToast(true);

        setLoading(false);
        if (type === 'donor') {
          setTimeout(() => {
            onHide('save');
          }, 2000);
        }
        // show success toast/snackbar here
      } catch (err) {
        setToastMessage(err.message);
        setToastVariant('error')
        setShowToast(true);
        
        setLoading(false);

        console.error("Update failed:", err);
        // show error message here
      }

    }
    else{
      setLoading(false);
      setToastMessage("Please fill all required fields");
      setToastVariant('error');
      setShowToast(true);
      console.log("Answers error:", answers);
    }
  };
  const renderQuestion = (q) => {
    if (!shouldDisplay(q)) return null;

    switch (q.question_field_type) {
      case "enum":
        return (
          <div key={q.id} className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-1">
                <div className="custom-list-style">
                    <li>
                        <label className="d-block mb-1">{q.question_title}</label>
                    </li>
                </div>
            <div>
              <label className="me-3">
                <input
                  className="form-check-input form-check-health-questionnaire-radio"
                  type="radio"
                  name={`q-${q.id}`}
                  value={1}
                  checked={answers[q.id] === 1}
                  onChange={() => handleAnswer(q.id, 1)}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  className="form-check-input  form-check-health-questionnaire-radio"
                  type="radio"
                  name={`q-${q.id}`}
                  value={0}
                  checked={answers[q.id] === 0}
                  onChange={() => handleAnswer(q.id, 0)}
                />{" "}
                No
              </label>
            </div>
            </div>
            {errors[q.id] && (
              <small className="text-danger">{errors[q.id]}</small>
            )}
          </div>
        );

      case "varchar":
        return (
          <div key={q.id} className="mb-3">
            <label className="d-block mb-1">{q.question_title}</label>
            <textarea
              className="form-control"
              value={answers[q.id] || ""}
              onChange={(e) => handleAnswer(q.id, e.target.value)}
            />
            {errors[q.id] && (
              <small className="text-danger">{errors[q.id]}</small>
            )}
          </div>
        );

     
      case "datetime":
        return (
          <div key={q.id} className="mb-3 w-30">
            <label className="d-block mb-1">{q.question_title}</label>
            <DatePicker
              selected={answers[q.id] ? new Date(answers[q.id]) : null}
              onChange={(date) => {
                handleAnswer(
                  q.id,
                  // date?.toLocaleDateString("en-US", {
                  //   month: "long",
                  //   day: "numeric",
                  //   year: "numeric",
                  // })
                  date ? format(date, "yyyy-MM-dd HH:mm:ss") : null
                );
              }}
              dateFormat="MMMM d, yyyy"    
              placeholderText="Month Date, Year"
              className="form-control"
            />
            {errors[q.id] && (
              <small className="text-danger">{errors[q.id]}</small>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={`${type !== 'donor' ? "el-bg-table el-super-admin mt-5" : "health-quesion-popup-accord"}`}>
      <Accordion className="el-custom-accordion" alwaysOpen defaultActiveKey={["3"]} flush>
      <Accordion.Item eventKey="3" id="donor-health-questionnaire-section">
        <Accordion.Header className="cursor-pointer" style={type === 'donor' ? { pointerEvents: "none" } : {}}>
          <div className="d-flex flex-column">
            {type !== 'donor' && (<>
              <b>Donor X Donor Health Questionnaire</b>
            </>)}
             {type === 'donor' && (<div className="m-auto">
              <h5>Donor X Donor Health Questionnaire</h5>
            </div>)}
            <p>
              Please fill out the following donor health questionnaire with
              accurate and honest information. The information provided is
              critical in establishing a self-reported donor health history.
              Information provided in this questionnaire does not automatically
              include or exclude you from participation in the Donor X program.
            </p>
          </div>
        </Accordion.Header>
        <Accordion.Body>
          {questions.map((group) => (
            <div key={group.id} className="mb-4">
             <div className="mb-3"> <h6><b>{group.hq_group_name}</b></h6></div>
             <ul>
              {group.health_questions.map((q) => renderQuestion(q))}
              </ul>
              <hr></hr>
            </div>
          ))}
          {type==='donor' && (<>
            <p className="text-danger">Note: Please update the information if there are any changes; otherwise, kindly review and proceed.</p> 
          </>)}
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
      {/* {JSON.stringify(errors)} */}
      <div className="d-flex">
        <div className="mt-3">
          <button type="submit" className="el-main-button me-3" onClick={handleSubmit}><span>{type!=='donor'? 'Save Changes' : 'Accept & Continue' }</span></button>
        </div>
        {type==='donor' && (<>
        <div>
          <button className="btn mt-3" type="button" onClick={onHide}>Cancel</button>
        </div>
        </>)}
      </div>
    </div>
  );
}

export default HealthQuestionnaire;
